import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { Observable, from } from 'rxjs';
import { PagedData, PagedDataUserMenu } from 'src/app/shared/models/paged-data';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { menuPageParams, PageParams } from 'src/app/shared/common/Enums';
import { TermsDocType } from 'src/app/shared/models/settings.model';
import { Page } from 'src/app/shared/models/page';
import { map } from 'rxjs/internal/operators/map';

@Injectable({
  providedIn: 'root'
})
export class TermsAndConditionService {


  constructor(
    private webApiService: WebApiService,

    ) { }

    // httpOptions: the sign-in page passes the just-issued session headers (id / hash) - the API takes the user from
    // the session, not from params.userId (2026-10-23).
    acceptTermsAndConditions(params:any, httpOptions: any = {}): Promise<any> {
        let apiUrl = `/users/terms/acceptTermsAndConditions`;
        return this.webApiService.postRequest<any>(apiUrl, params, httpOptions)

    }

    async fetchAllUserTermsAcceptanceData(params:any): Promise<any> {
      let apiUrl = `/users/terms/fetchAllUserTermsAcceptanceData`;
      return this.webApiService.postRequest<any>(apiUrl, params
      );
    }

    async sendTermsAcceptanceReminder(params:any): Promise<any> {
      let apiUrl = `/users/terms/sendTermsAcceptanceReminder`;
      return this.webApiService.postRequest<any>(apiUrl, params
      );
    }

    async sendTermsAcceptanceMail(params:any, httpOptions: any = {}): Promise<any> {
      let apiUrl = `/users/terms/sendTermsAcceptanceMail`;
      return this.webApiService.postRequest<any>(apiUrl, params, httpOptions
      );
    }

    
    async addNewTermsDocType(params:any): Promise<any> {
      let apiUrl = `/users/terms/addNewTermsDocType`;
      return this.webApiService.postRequest<any>(apiUrl, params
      );
    }

    getAllTermsDocTypeByFliterValue(
      _filterValue: any,
      pageMetaData?: Page
    ): Observable<PagedData<TermsDocType>> {
      let _pageMetadata = new Page();
      let apiUrl = '/settings/getAllTermsDocTypeByFliterValue'
  
      if (pageMetaData) {
        _pageMetadata = pageMetaData;
      } else {
        _pageMetadata.pageNumber = 0;
        _pageMetadata.size = 10;
      }
      /**
       * Set request params for pagination variables.
       * @pageNumber Add +1 in PageNumber as page start with 0 in frontend data-table.
       */
      let params = new HttpParams()
        .set(PageParams.limit, _pageMetadata.size)
        .set(PageParams.page, _pageMetadata.pageNumber + 1)
        .set('filterValue', _filterValue);
  
      return this.webApiService
        .getPaginatedRequest<PagedData<TermsDocType>>(
          apiUrl,
          params
        )
        .pipe(
          map((paginedDocType) => {
            // Set page metadata for frontend table properties
            paginedDocType.page.totalElements = paginedDocType.count;
            paginedDocType.page.size = _pageMetadata.size;
            paginedDocType.page.totalPages = Math.floor(
              paginedDocType.count / _pageMetadata.size
            );
            paginedDocType.page.pageNumber = _pageMetadata.pageNumber;
            paginedDocType.page.serachParam = _pageMetadata.serachParam;
  
            return paginedDocType;
          })
        );
    }
    
    async getAllTermsDocType(section:string): Promise<any> {
      let apiUrl = `/users/terms/getAllTermsDocType`;
      let params = new HttpParams()
      .set('section', section);
      return this.webApiService.getRequest<any>(apiUrl, params
      );
    }

    async getLatestUserPolicyByUserCategory(userType:string): Promise<any> {
      let apiUrl = `/users/terms/getLatestUserPolicyByUserCategory`;
      let params = new HttpParams()
      .set('userType', userType);
      return this.webApiService.getRequest<any>(apiUrl, params
      );
    }


    async uploadTermsDocument(params:any): Promise<any> {
      let apiUrl = `/users/terms/uploadTermsDocument`;
      return this.webApiService.postRequest<any>(apiUrl, params
      );
    }

    async uploadDraftTermsDocument(params:any): Promise<any> {
      let apiUrl = `/users/terms/uploadDraftTermsDocument`;
      return this.webApiService.postRequest<any>(apiUrl, params
      );
    }

    async approvedDraftTermsDocument(params:any): Promise<any> {
      let apiUrl = `/users/terms/approvedDraftTermsDocument`;
      return this.webApiService.postRequest<any>(apiUrl, params
      );
    }

    async createNewTermsPolicy(params:any): Promise<any> {
      let apiUrl = `/users/terms/createNewTermsPolicy`;
      return this.webApiService.postRequest<any>(apiUrl, params
      );
    }
    
    async getAllInActiveTermsDocs(userType:string): Promise<any> {
      let apiUrl = `/users/terms/getAllInActiveTermsDocs`;
      let params = new HttpParams()
      .set('userType', userType);
      return this.webApiService.getRequest<any>(apiUrl, params
      );

      
    }

    async getAllPolicyHistoricData(): Promise<any> {
      let apiUrl = `/users/terms/getAllPolicyHistoricData`;
      return this.webApiService.getRequest<any>(apiUrl
      );

      
    }


    


    
    
    

    

}